import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-asp-confirm-order-popup',
  templateUrl: './asp-confirm-order-popup.component.html',
  styleUrls: ['./asp-confirm-order-popup.component.scss'],
  providers: [ DatePipe ]
})
export class AspConfirmOrderPopupComponent implements OnInit {
  successIcon: any;
  order:any;
  sidebarOpen: boolean;
  isMobile: boolean;
  missingArray: string;
  magicOrder: boolean;
  createOrder: boolean;
  requestId: string;
  roleType: string;
  isEmployee: boolean = false;

  constructor(
    private router: Router,
    private date: DatePipe,
    private breakpointObserver: BreakpointObserver,
    public dialog:MatDialogRef<AspConfirmOrderPopupComponent>
  ) {
    this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); 
    dialog.disableClose = true;
   }

  ngOnInit(): void {    
    this.roleType = localStorage.getItem('roleType');

    if (this.roleType === 'autoverse_employee') {
      this.isEmployee = true;
    }
    this.successIcon = '../../../../assets/icons/icons8-ok.gif';
    this.order = JSON.parse(sessionStorage.getItem('order'));
    this.order.orderDate = new Date(this.order.orderDate+' UTC');
    this.order.orderDate = this.date.transform(this.order.orderDate, 'MMM dd yyyy hh:mm a');
    this.order.dropoffLocation = this.formatText(this.order.dropoffLocation);
    this.order.pickupLocation  = this.formatText(this.order.pickupLocation);
    if(localStorage.getItem('instantOrderPay')== 'true'){
      this.magicOrder=true;
      
  this.missingArray=JSON.parse(localStorage.getItem('missingItemNames'));
  this.requestId=localStorage.getItem('requestId');
    }else{
      this.createOrder=true;
   
    if(!this.isMobile){
      (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
    }else{
      (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
    }
  }
  
    this.clearLocalStorage();
  }

    formatText(text: string): string {
    if (!text) return '';

    return text
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }
  closePopup(){
    this.dialog.close();
    this.router.navigate(['home']);
  }
  onOverlayClick() {
  this.closePopup(); // same behavior as clicking X
}
 goToOrder(){
  this.closePopup();
  window.location.href = '/order-list';

  // this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
  //   this.router.navigate(['order-list']);
  // });
}


  private clearLocalStorage(){
    localStorage.removeItem('vehicleType');
    localStorage.removeItem('newMake');
    localStorage.removeItem('newModel');
    localStorage.removeItem('newYear');
    localStorage.removeItem('newVariant');
    localStorage.removeItem('newVariantKey');
    localStorage.removeItem('newRowKey');
    localStorage.removeItem('prepayUpiDiscount');
    localStorage.removeItem('registrationNumber');
    localStorage.removeItem('selectedFuel');
    localStorage.removeItem('fuelType');
    localStorage.removeItem('vehicleData');


    localStorage.removeItem('selectedMake');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('variant');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('rowKey');
    sessionStorage.removeItem('sparePartsDetails');

    // razorpay
    sessionStorage.removeItem('rzp_device_id');
    sessionStorage.removeItem('isShippingCharges');
    sessionStorage.removeItem('rzp_checkout_anon_id');
      localStorage.removeItem("slotid");
       localStorage.removeItem("slotName");
       localStorage.removeItem("slotWarehouseName");
     if(localStorage.getItem('instantOrderPay')== 'true'){
    sessionStorage.removeItem('instantOrder')
    localStorage.removeItem('requestId');
     }else{
    sessionStorage.removeItem('orderData');
    localStorage.removeItem('addedCart');
    localStorage.removeItem('walletBalance');
    localStorage.removeItem('redeemCart');
    localStorage.removeItem('addedRedeem');
    
     }
  };
  requestSuccessPopup(){
   this.closePopup();
this.router.navigate(['my-request']); 

    sessionStorage.removeItem('instantOrder')
    localStorage.removeItem('requestId');
    localStorage.removeItem('instantOrderPay')
  // this.successPopup=true;
  // this.placeOrder=false;
}

}
